<div class="popup-overlay">
  <div class="popup-content">
    <h2>{{ title }}</h2>
    <div class="popup-card">
      <div *ngFor="let key of objectKeys(data)">
        <label>{{ key | titlecase }}:</label>
        <span>{{ formatValue(data[key]) }}</span>
      </div>
    </div>
    <div class="buttons-container">
        <button class="cancel-btn" (click)="onClose()" aria-label="Close"><i class="fas fa-times"></i></button>
    </div>
  </div>
</div>
